"use client";

import { disablePageScroll, enablePageScroll } from "scroll-lock";
import {MenuSvg} from "./NavHelp";
import { HamburgerMenu } from "./NavHelp";
import { useState, useEffect } from "react";
import Link from "next/link";

import { authClient } from "../../lib/auth-client";

export const navigation = [
  {
    id: "0",
    title: "Testimonials",
    url: "#testimonial",
  },
  {
    id: "1",
    title: "Pricing",
    url: "#pricing",
  },
  {
    id: "2",
    title: "FAQs",
    url: "#faqs",
  },
];

const Header = () => {
  const [openNavigation, setOpenNavigation] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [userState, setUserState] = useState(false);
  const [role, setRole] = useState(false)
  const { data: session, isPending } = authClient.useSession();
  

  // ✅ Move the return inside the component

  
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (session) {
      setUserState(true);
      setRole(session.user?.role !== "USER");
    } else {
      setUserState(false);
      setRole(false);
    }
  }, [session, isPending]);
  
  const toggleNavigation = () => {
    setOpenNavigation((prev) => {
      const newState = !prev;
      newState ? disablePageScroll() : enablePageScroll();
      return newState;
    });
  };

  const handleClick = (e) => {
    e.preventDefault();
    const href = e.currentTarget.getAttribute("href");
    const targetId = href?.substring(1);

    if (targetId) {
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
        window.history.pushState({}, "", href);
      }
    }

    if (openNavigation) {
      enablePageScroll();
      setOpenNavigation(false);
    }
  };
  
  
  return (
    <>
      <style jsx global>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fadeInUp {
          animation: fadeInUp 0.6s ease-out forwards;
        }

        .mobile-menu-btn {
          position: relative;
          padding: 0.75rem;
          border-radius: 0.75rem;
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(147, 51, 234, 0.1));
          transition: all 0.3s ease;
          color: rgb(37, 99, 235);
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          transform: scale(1);
        }

        .mobile-menu-btn:hover {
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(147, 51, 234, 0.2));
          color: rgb(29, 78, 216);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          transform: scale(1.05);
        }
      `}</style>

      <div
        className={`fixed top-0 left-0 w-full z-50 border-b transition-all ${
          isScrolled || openNavigation
            ? "bg-white shadow-lg"
            : "bg-transparent"
        }`}
      >
        <div className="flex items-center px-5 lg:px-7.5 xl:px-10 max-lg:py-4">
          <a className="block w-[12rem] xl:mr-8" href="#hero">
            <div className="h-16 flex items-center">
              <img 
                src="/images/logo.jpg" 
                alt="Source It Shipping Logo"
                className="h-full max-h-16 object-contain" 
              />
            </div>
          </a>
       
          <nav
            className={`${
              openNavigation ? "flex" : "hidden"
            } fixed top-[5rem] left-0 right-0 bottom-0 bg-white lg:static lg:flex lg:mx-auto lg:bg-transparent transition-all duration-300 ease-out z-40`}
          >
            <div className="relative z-10 flex flex-col items-center justify-center m-auto lg:flex-row w-full">
              {navigation.map((item, index) => (
                <a
                  key={item.id}
                  href={item.url}
                  onClick={handleClick}
                  className={`
                    group block cursor-pointer relative font-medium text-xl uppercase 
                    transition-all duration-300 ease-out hover:text-blue-600 
                    ${item.onlyMobile ? "lg:hidden" : ""} 
                    px-8 py-6 md:py-8 lg:-mr-0.25 lg:text-xs lg:font-semibold 
                    ${isScrolled ? "text-gray-800" : "text-blue-600"} 
                    xl:px-12 transform hover:scale-105 hover:-translate-y-1
                    ${openNavigation ? 'animate-fadeInUp' : ''}
                  `}
                  style={{
                    animationDelay: openNavigation ? `${index * 0.1}s` : '0s'
                  }}
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10 scale-95 group-hover:scale-100"></div>
                  
                  <div className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-gradient-to-br from-blue-400 to-purple-500 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-300 transform group-hover:scale-110"></div>
                    <span className="relative">
                      {item.title}
                      <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-blue-500 to-purple-500 group-hover:w-full transition-all duration-300"></div>
                    </span>
                  </div>
                </a>
              ))}
        
              
              <div className="mt-8 lg:hidden">
                {userState ? (
                  <Link
                    href="/dashboard"
                    className="relative inline-flex items-center justify-center px-8 py-4 overflow-hidden font-semibold text-white transition-all duration-300 bg-gradient-to-r from-gray-800 to-gray-900 rounded-2xl group hover:from-gray-900 hover:to-black shadow-lg hover:shadow-xl transform hover:scale-105"
                    onClick={() => {
                      if (openNavigation) {
                        enablePageScroll();
                        setOpenNavigation(false);
                      }
                    }}
                  >
                    <span className="absolute top-0 right-0 inline-block w-4 h-4 transition-all duration-500 ease-in-out bg-gray-700 rounded group-hover:-mr-4 group-hover:-mt-4">
                      <span className="absolute top-0 right-0 w-5 h-5 rotate-45 translate-x-1/2 -translate-y-1/2 bg-white"></span>
                    </span>
                    <span className="absolute bottom-0 left-0 w-full h-full transition-all duration-500 ease-in-out delay-200 -translate-x-full translate-y-full bg-gray-600 rounded-2xl group-hover:mb-12 group-hover:translate-x-0"></span>
                    <span className="relative text-lg font-semibold">
                      Go to Dashboard
                    </span>
                  </Link>
                ) : (
                  <Link
                    href="/signup"
                    className="relative inline-flex items-center justify-center px-8 py-4 overflow-hidden font-semibold text-white transition-all duration-300 bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl group hover:from-blue-600 hover:to-purple-700 shadow-lg hover:shadow-xl transform hover:scale-105"
                    onClick={() => {
                      if (openNavigation) {
                        enablePageScroll();
                        setOpenNavigation(false);
                      }
                    }}
                  >
                    <span className="absolute top-0 right-0 inline-block w-4 h-4 transition-all duration-500 ease-in-out bg-blue-700 rounded group-hover:-mr-4 group-hover:-mt-4">
                      <span className="absolute top-0 right-0 w-5 h-5 rotate-45 translate-x-1/2 -translate-y-1/2 bg-white"></span>
                    </span>
                    <span className="absolute bottom-0 left-0 w-full h-full transition-all duration-500 ease-in-out delay-200 -translate-x-full translate-y-full bg-purple-700 rounded-2xl group-hover:mb-12 group-hover:translate-x-0"></span>
                    <span className="relative text-lg font-semibold">
                      Register Today
                    </span>
                  </Link>
                )}
              </div>
            </div>
      
            <HamburgerMenu />
          </nav>

          {userState ? (
            <Link
              href="/dashboard"
              className="relative hidden lg:inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium transition-all bg-gray-900 rounded-xl group"
            >
              <span className="absolute top-0 right-0 inline-block w-4 h-4 transition-all duration-500 ease-in-out bg-gray-800 rounded group-hover:-mr-4 group-hover:-mt-4">
                <span className="absolute top-0 right-0 w-5 h-5 rotate-45 translate-x-1/2 -translate-y-1/2 bg-white"></span>
              </span>
              <span className="absolute bottom-0 left-0 w-full h-full transition-all duration-500 ease-in-out delay-200 -translate-x-full translate-y-full bg-gray-700 rounded-2xl group-hover:mb-12 group-hover:translate-x-0"></span>
              <span className="relative w-full text-base font-semibold text-left text-white transition-colors duration-200 ease-in-out group-hover:text-white">
                Dashboard
              </span>
            </Link>
          ) : (
            <Link
              href="/signup"
              target="_blank"
              rel="noopener noreferrer"
              className="relative hidden lg:inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium transition-all bg-gray-900 rounded-xl group"
            >
              <span className="absolute top-0 right-0 inline-block w-4 h-4 transition-all duration-500 ease-in-out bg-gray-800 rounded group-hover:-mr-4 group-hover:-mt-4">
                <span className="absolute top-0 right-0 w-5 h-5 rotate-45 translate-x-1/2 -translate-y-1/2 bg-white"></span>
              </span>
              <span className="absolute bottom-0 left-0 w-full h-full transition-all duration-500 ease-in-out delay-200 -translate-x-full translate-y-full bg-gray-700 rounded-2xl group-hover:mb-12 group-hover:translate-x-0"></span>
              <span className="relative w-full text-base font-semibold text-left text-white transition-colors duration-200 ease-in-out group-hover:text-white">
                Register Today
              </span>
            </Link>
          )}

          <button
            className="ml-auto lg:hidden mobile-menu-btn"
            onClick={toggleNavigation}
            aria-label="Toggle navigation"
          >
            <MenuSvg openNavigation={openNavigation} />
          </button>
        </div>
      </div>
    </>
  );
};

export default Header;